import {
  FormStageStage,
  TFormState,
} from '@/ui/components/createPurchaseOrderSidebar/CreatePurchaseOrderSidebar';
import { PurchaseOrderDeliveryAddressControl } from '@/ui/components/purchaseOrderDeliveryAddressControl/PurchaseOrderDeliveryAddressControl';
import {
  Button,
  Checkbox,
  Conditional,
  DateInput,
  Field,
  Textarea,
} from '@payaca/ambrosia';

import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export interface IProps {
  formStage: FormStageStage;
  projectId: number;
  hideList?: boolean;
  isSaving: boolean;
}

const IndirectPurchaseOrderDetails: FC<IProps> = (props) => {
  const { formStage, projectId, hideList = false, isSaving } = props;

  const formMethods = useFormContext<TFormState>();

  const selectedSupplierId = formMethods.watch('supplierId');

  return (
    <div className="bg-gray-50 p-3.5 border-l">
      <div
        className={clstx('flex flex-col gap-4 h-full', hideList && 'hidden')}
      >
        <h4>Order details</h4>

        <Field.Legacy
          validationState={
            'dueAt' in formMethods.formState.errors
              ? {
                  isValid: false,
                  validationMessages: ['Due by required'],
                }
              : undefined
          }
        >
          <Field.Label>Due by</Field.Label>

          <Conditional
            condition={
              formStage === 'INDIRECT_PURCHASE_ORDER_DETAILS' || !hideList
            }
          >
            <Controller
              name="dueAt"
              control={formMethods.control}
              render={({ field: { onChange, value } }) => {
                return <DateInput value={value} onChange={onChange} />;
              }}
            />
          </Conditional>
        </Field.Legacy>

        <Field.Legacy>
          <Field.Label>Deliver to</Field.Label>

          <Controller
            name="deliveryInfo"
            control={formMethods.control}
            render={({ field: { onChange, value } }) => {
              return (
                <PurchaseOrderDeliveryAddressControl
                  supplierId={selectedSupplierId}
                  projectId={projectId}
                  onChange={onChange}
                  value={value}
                />
              );
            }}
          />
        </Field.Legacy>

        <Field.Legacy name="additionalNotes">
          <Field.Label>Additional notes</Field.Label>

          <Controller
            name="additionalNotes"
            control={formMethods.control}
            render={({ field: { onChange, value, onBlur } }) => {
              return (
                <Textarea value={value} onChange={onChange} onBlur={onBlur} />
              );
            }}
          />
        </Field.Legacy>

        <Field.Legacy name="showMaterialPrices">
          <Checkbox
            label="Show Material prices on Purchase Order"
            {...formMethods.register('showMaterialPrices')}
          />
        </Field.Legacy>

        <Button
          className="mt-auto"
          type="submit"
          isProcessing={isSaving}
          disabled={isSaving}
        >
          Create order
        </Button>
      </div>
    </div>
  );
};

export default IndirectPurchaseOrderDetails;
